<template>
	<div id="app">
		<div v-show="showCsos">
			<!-- <p class="devops-alert" :class="{showMessage: 'show'}" v-if="showMessage && !isOnMobile">
          {{message.text}}
        <button type="button" class="close" @click="closeDevops">
          <span aria-hidden="true">×</span>
        </button>
      </p> -->
			<router-view v-if="showCsos"></router-view>
		</div>
	</div>
</template>

<script>
// import STORE_CONST from './store/consts'
// ipad mobile路由没有引用store，所以app.vue中不能使用store发请求，应直接使用Api调用
import accountApi from './api/account'
import { baseUrl } from './config'
import Utility from './Utils'
export default {
	name: 'app',
	data() {
		return {
			showCsos: false,
			showMessage: '',
			message: '',
			isOnMobile: true,
		}
	},
	created() {
		//      this.getNotify()
		console.log('Utility.Utils.isOnMobile()', Utility.Utils.isOnMobile())
		this.isOnMobile = Utility.Utils.isOnMobile()
		const homeParams = {
			token: this.getUrlParams('cc_sso_token'),
			cf_token: this.getUrlParams('cf_sso_token'),
		}
		if (homeParams.token) {
			console.log('has home params!!!')
			accountApi
				.loginSSO(
					{
						token: homeParams.token,
					},
					true
				)
				.then(
					(res) => {
						if (res.data) {
							if (window.location.href.indexOf('ipad.html') >= 0) {
								this.showCsos = true
								this.isPc = false
							} else if (window.location.href.indexOf('mobile.html') >= 0) {
								this.showCsos = true
								this.isPc = false
							} else {
								window.location.href = '/console.html'
								this.isPc = true
							}
						}
					},
					() => {
						console.log('ssologin error:')
						window.top.location.href = baseUrl.ccLogout
					}
				)
		} else if (homeParams.cf_token) {
			accountApi.loginCFSSO({ token: homeParams.cf_token }, true).then(
				(res) => {
					if (res.data) {
						if (window.location.href.indexOf('ipad.html') >= 0) {
							this.showCsos = true
							this.isPc = false
						} else if (window.location.href.indexOf('mobile.html') >= 0) {
							this.showCsos = true
							this.isPc = false
						} else {
							window.location.href = '/console.html'
							this.isPc = true
						}
					}
				},
				() => {
					window.top.location.href = baseUrl.ccLogout
				}
			)
		} else {
			console.log('not has home params!!!')
			this.showCsos = true
		}
	},
	methods: {
		closeDevops() {
			this.showMessage = false
			let obj = {
				text: this.message.text,
				id: this.message.id,
			}
			localStorage.setItem('CSOS-DEOPSALERT__KEY', JSON.stringify(obj))
		},
		getUrlParams(_key) {
			const reg = new RegExp('(^|&)' + _key + '=([^&]*)(&|$)', 'i')
			let r = window.location.search.substr(1).match(reg)
			if (r != null) {
				return unescape(r[2])
			}
			return null
		},
		checkShowNotify(message) {
			if (localStorage.getItem('CSOS-DEOPSALERT__KEY')) {
				let obj = JSON.parse(localStorage.getItem('CSOS-DEOPSALERT__KEY'))
				if (obj.text && obj.text === message.text && obj.id === message.id) {
					this.showMessage = false
				} else {
					this.showMessage = true
				}
			} else {
				this.showMessage = true
			}
		},
		getNotify() {
			let params = {
				baseURL: baseUrl.homeApiUrl,
			}
			console.log('this', this.$store)
			accountApi.notifyBanner(params).then((res) => {
				if (res && res.data && res.data.data) {
					this.message = res.data.data
					this.checkShowNotify(this.message)
				}
			})
		},
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import 'assets/css/variable';

* {
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	padding: 0;
	margin: 0;
}
html,
body {
	background: #eff3f4;
	margin: 0;
	padding: 0;
	font-family: '微软雅黑', '黑体', '宋体', 'Microsoft Yahei', 'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-text-size-adjust: none;
	font-size: 14px;
	width: 100%;
	// height: 100%;
	color: #666;
	/*overflow-x: hidden;*/
}

#app {
	width: 100%;
	// height: 100%;
	> div {
		height: 100%;
		> div {
			height: 100%;
			color: #666;
		}
	}
}
ul {
	text-decoration: none;
	list-style-type: none;
	padding: 0;
	margin: 0;
	li {
		text-decoration: none;
		list-style: none;
	}
}

a {
	text-decoration: none;
}

.pull-left {
	float: left;
}

.pull-right {
	float: right;
}

.text-left {
	text-align: left;
}

.text-right {
	text-align: right;
}

.text-center {
	text-align: center;
}

.clearfix {
	*zoom: 1;
}

.clearfix:before,
.clearfix:after {
	display: table;
	line-height: 0;
	content: '';
}

.clearfix:after {
	clear: both;
}

.el-table .info-row {
	background: $bgColor;
}

.el-tabs__header {
	background-color: #fff;
	padding-left: 20px;
	padding-top: 10px;
}

.el-tabs__content {
	padding: 0 20px;
}

.el-input__inner {
	border-radius: 0;
	height: 32px;
}

.el-table__header-wrapper thead div {
	background-color: #fff;
}
.el-table__fixed-header-wrapper thead div {
	background-color: #fff;
}
.el-table th {
	background-color: #fff;
}

.el-table {
	.cell {
		/*overflow: hidden;*/
		/*white-space: nowrap;*/
		/*text-overflow: ellipsis;*/
	}
}

.el-form-item.is-required .el-form-item__label:before {
	content: '';
}

.el-progress-bar__outer {
	border-radius: 0;
	.el-progress-bar__inner {
		border-radius: 0;
	}
}
.el-notification__content {
	text-align: inherit;
}
.pagination {
	position: relative;
	padding: 25px 0;
	background-color: #fff;
	.el-pagination {
		position: absolute;
		top: 8px;
		right: 0;
	}
}

.detail-btn {
	position: absolute;
	bottom: 0;
	right: 0;
	width: 100%;
	text-align: center;
	.el-button {
		padding: 10px 30px;
		border-radius: 0;
	}
}

.csos-tabs {
	.el-tabs--card > .el-tabs__header .el-tabs__item {
		margin: 0 5px;
		border: 1px solid #d1dbe5;
		border-bottom-color: #eff3f4;
		border-radius: 0px 0px 0 0;
	}
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
	border-bottom-color: #eff3f4;
	border-radius: 0px 0px 0 0;
	background: #eff3f4;
	color: #3e84fc;
}

.el-select .el-input__inner {
	color: $textColor;
}

.el-button {
	border-radius: 0;
}

.wrapper-padding {
	padding: 15px;
}

.el-table__body-wrapper {
	overflow: hidden;
}
.el-button--text {
	margin-left: 4px;
}
.chart path.nv-point {
	fill: #fff;
	fill-opacity: 1 !important;
	stroke-opacity: 1 !important;
}
.chart path.nv-point.hover {
	fill: none !important;
}

.chart .nv-x .tick line {
	display: none;
}
.chart .nvd3 .nv-axis path {
	fill: none;
	stroke: #ccc;
	stroke-opacity: 0.75;
	shape-rendering: crispEdges;
}
.chart .nvd3 .nv-axis .nv-axisMaxMin text {
	font-weight: normal;
}
.chart .nv-interactiveGuideLine line {
	stroke: #529afc;
	fill: none;
	stroke-dasharray: 5, 3;
	stroke-width: 1;
}

.chart {
	.nv-y.nv-axis {
		.nv-zeroLine line {
			opacity: 0;
		}
	}
}

.chart.bar-chart {
	.nvd3 .nv-axis path {
		display: none;
	}
}
.nvd3 .nv-y.nv-axis .nv-zeroLine line {
	opacity: 0;
}
.nvd3 .nv-axis .zero line,
.nvd3 .nv-axis line.zero {
	stroke-opacity: 0;
}
.nvd3 .nv-discretebar .nv-groups text,
.nvd3 .nv-multibarHorizontal .nv-groups text,
.nvd3.nv-axis .nv-axisMaxMin text {
	font-weight: 400 !important;
}

.login {
	.login-logo {
		padding: 10px 20px;
		background-color: #fff;
		img {
			// width: 150px;
			height: 30px;
		}
	}
	.container {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -60%);
		text-align: center;
		width: 500px;
		.content-wrapper {
			background-color: #fff;
			border: 1px solid $border-color;
			box-shadow: 0 2px $border-color;
			margin-top: 40px;
			.content-titel {
				padding-left: 20px;
				height: 35px;
				line-height: 35px;
				text-align: left;
				background-color: $bgColor;
				border-top: 1px solid $border-color;
				border-bottom: 1px solid $border-color;
			}
		}
	}
	.login-link {
		text-decoration: none;
		color: $textColor;
		&:hover {
			color: $mainColor;
		}
	}
	.copyright {
		position: fixed;
		bottom: 20px;
		width: 100%;
		font-size: 13px;
		text-align: center;
		.text-primary {
			color: #7266ba;
		}
	}
	.logo-item1 {
		display: block;
		width: 150px;
		height: 42px;
		margin: 0 auto;
	}
}
.devops-alert {
	width: 100%;
	line-height: 30px;
	text-align: center;
	color: #a94442;
	background-color: #f2dede;
	border-color: #ebccd1;
}
.close {
	float: right;
	font-size: 21px;
	font-weight: 700;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	filter: alpha(opacity=20);
	opacity: 0.2;
	position: relative;
	top: 2px;
	right: 8px;
	color: inherit;
}
button.close,
button.close:active {
	-webkit-appearance: none;
	padding: 0;
	cursor: pointer;
	background: 0 0;
	border: 0;
}
.CodeMirror-hints {
	z-index: 10000 !important;
}
</style>



// WEBPACK FOOTER //
// App.vue?7892ad71